import supabase from "@/services/supabaseClient.js";
import { getRuntimeHostname, isStagingRuntimeHost } from "@/services/stagingAccessService.js";

export async function seedStagingPharmacyDemoData({ ownerUserId = "" } = {}) {
  const normalizedOwnerUserId = String(ownerUserId || "").trim();
  if (!normalizedOwnerUserId || !isStagingRuntimeHost(getRuntimeHostname())) {
    return { ok: false, skipped: true, reason: "not_staging_or_missing_owner" };
  }

  const { data, error } = await supabase.rpc("seed_staging_pharmacy_demo_data", {
    p_owner_user_id: normalizedOwnerUserId,
    p_action: "seed",
  });

  if (error || data?.ok === false) {
    throw new Error(
      data?.message ||
        data?.error ||
        error?.message ||
        "Could not prepare pharmacy demo data.",
    );
  }

  return data || { ok: true };
}
